import { useQuery } from '@apollo/client'
import { SearchableCombobox, TSearchable } from '../base/combobox'
import { MaintenanceTypesSelectorQuery, SelectedMaintenanceTypeSelectorQuery } from './__generated__/selector_query'
import { Query, SelectedQuery } from './selector_query'
import { useCombobox } from '@/helpers/useCombobox'
import { dedupe } from '@/helpers/dedupe'

type Asset = SelectedMaintenanceTypeSelectorQuery['maintenanceTypes']['nodes'][0]

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { data: selectedData } = useQuery<SelectedMaintenanceTypeSelectorQuery>(
    SelectedQuery,
    { variables: { id: value || 'blank' } }
  )
  const { data, loading, refetch, fetchMore } = useQuery<MaintenanceTypesSelectorQuery>(Query)

  const { pageInfo, items } = useCombobox<Asset>({
    pageInfo: data?.maintenanceTypes.pageInfo,
    querySelected: selectedData?.maintenanceTypes.nodes[0],
    queryCollection: data?.maintenanceTypes.nodes,
    buildSearchable: item => ({
      id: item.id,
      name: item.name
    })
  })

  return (
    <SearchableCombobox
      data={items}
      includeBlank={false}
      invalid={invalid}
      loading={loading}
      moreToFetch={pageInfo.current?.hasNextPage}
      refetch={refetch}
      searchField="idEq"
      value={items.find(d => d.id == value) || { id: '', name: '' }}
      fetchMore={() => fetchMore({
        variables: { after: pageInfo.current?.endCursor },
        updateQuery(previousData, { fetchMoreResult }) {
          if (Object.keys(previousData).length === 0) return fetchMoreResult
          fetchMoreResult.maintenanceTypes.nodes = dedupe([
            ...previousData.maintenanceTypes.nodes,
            ...fetchMoreResult.maintenanceTypes.nodes
          ])

          return { ...fetchMoreResult }
        }
      })}
      onChange={onChange}
    />
  )
}
